import { render } from "./EditImmigration.vue?vue&type=template&id=a5fb09aa"
import script from "./EditImmigration.vue?vue&type=script&lang=js"
export * from "./EditImmigration.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__